/**
 * created by li si yi
 * 微博待办处理
 */
import React, {Component} from 'react';
import AllWeiboList from "../../../../mediaRelease/microblog/AllWeiboList";
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";

class WeiBo extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};

    isSupport(data) {
        // console.log('微博111111111111', data);
        this.data = data;
        if (this.data && this.data.data && this.data.data.id && this.data.data.mediaId && this.data.activitiCategoryKey === "weibo") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'MicroblogIcon';
        return icon
    };
    handle = (data, call) => {
        if (data && data.data && data.data.id) {
            this.allWeiboList.showWeibo(data.data.id, data.data.mediaId, () => {
                call && call();
            })
        }
    };

    render() {
        return (
            <div style={{display: 'none'}}>
                <AllWeiboList ref={ref => this.allWeiboList = ref}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(WeiBo)